<template>
    <CompassButton
        v-bind="$attrs"
        :label="label"
        :type="type"
        :size="size"
        :disabled="disabled"
        :leftIcon="leftIcon"
        :dropdown="dropdown"
        :loading="loading"
        :submit="submit"
        class="ai-button"
    />
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'primary',
        },
        size: {
            type: String,
            default: 'small',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        leftIcon: {
            type: String,
            default: '',
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        submit: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.ai-button {
    :deep() {
        &.compass-button--primary:not(:disabled) {
            background: var(--colors-sellsy-ai-gradient);

            &:hover {
                box-shadow: inset 0 0 0 100px #00000026;
            }
        }
        &.compass-button--secondary:not(:disabled) {
            color: var(--colors-sellsy-ai-100);
            border: 1px solid var(--colors-sellsy-ai-20);

            .compass-heading {
                color: var(--colors-sellsy-ai-100);
            }

            &:hover {
                border: 1px solid var(--colors-sellsy-ai-100);
            }
        }
        &.compass-button--primary-contrast {
            &:not(:disabled) {
                background: var(--colors-sellsy-ai-0);
                color: var(--colors-sellsy-ai-100);

                .compass-button__label {
                    color: var(--colors-sellsy-ai-100);
                }

                &:hover {
                    background: var(--colors-common-background-default);
                }
            }

            &:disabled {
                background: var(--colors-common-background-contrast-disabled);
                color: var(--colors-common-text-contrast-disabled);

                .compass-button__label {
                    color: var(--colors-common-text-contrast-disabled);
                }
            }
        }
        &.compass-button--tertiary:not(:disabled) {
            background-color: var(--colors-sellsy-ai-0);
            color: var(--colors-sellsy-ai-100);

            .compass-button__label {
                color: var(--colors-sellsy-ai-100);
            }

            &:hover {
                background: var(--colors-sellsy-ai-05);
            }
        }
        &.compass-button--tertiary-contrast:not(:disabled) {
            color: var(--colors-sellsy-ai-50);

            .compass-button__label {
                color: var(--colors-sellsy-ai-50);
            }

            &:hover {
                background: var(--colors-sellsy-ai-05);
            }
        }
    }
}
</style>
